import { 
  GET_TASK_TYPE,
  GET_TASK_TYPE_SUCCESS,
  GET_TASK_TYPE_ERROR,

  GET_TASK_TYPES_LIST,
  GET_TASK_TYPES_LIST_SUCCESS,
  GET_TASK_TYPES_LIST_ERROR,
  
  CREATE_TASK_TYPE,
  CREATE_TASK_TYPE_SUCCESS,
  CREATE_TASK_TYPE_ERROR, 

  UPDATE_TASK_TYPE,
  UPDATE_TASK_TYPE_SUCCESS,
  UPDATE_TASK_TYPE_ERROR,

  DELETE_TASK_TYPE,
  DELETE_TASK_TYPE_SUCCESS,
  DELETE_TASK_TYPE_ERROR,
} from "./actionTypes"
  
  const initialState = {
    GET_TASK_TYPE_SUCCESS: "",
    GET_TASK_TYPE_ERROR: "",
    GET_TASK_TYPES_LIST_SUCCESS: "",
    GET_TASK_TYPES_LIST_ERROR: "",
    CREATE_TASK_TYPE_SUCCESS: "",
    CREATE_TASK_TYPE_ERROR: "",
    UPDATE_TASK_TYPE: "",
    UPDATE_TASK_TYPE_SUCCESS: "",
    UPDATE_TASK_TYPE_ERROR: "",
    DELETE_TASK_TYPE: "",
    DELETE_TASK_TYPE_SUCCESS: "",
    DELETE_TASK_TYPE_ERROR: "",
    loading: false,
  }
  
  const reducer = (state = initialState, action: any) => {
    switch (action.type) {
      // ---------------------------------------------GET_TASK_TYPE
      case GET_TASK_TYPE:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_TASK_TYPE_SUCCESS:
        state = {
          ...state,
          GET_TASK_TYPE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_TASK_TYPE_ERROR:
        state = { 
          ...state, 
          GET_TASK_TYPE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------GET_TASK_TYPES_LIST
      case GET_TASK_TYPES_LIST:
        state = {
          ...state,
          loading: true,
        }
        break

      case GET_TASK_TYPES_LIST_SUCCESS:
        state = {
          ...state,
          GET_TASK_TYPES_LIST_SUCCESS: action.payload,
          loading: false,
        }
        break

      case GET_TASK_TYPES_LIST_ERROR:
        state = { 
          ...state, 
          GET_TASK_TYPES_LIST_ERROR: action.payload, 
          loading: false 
        }
        break
        
      // ---------------------------------------------CREATE_TASK_TYPE
      case CREATE_TASK_TYPE:
        state = {
          ...state,
          loading: true,
        }
        break

      case CREATE_TASK_TYPE_SUCCESS:
        state = {
          ...state,
          CREATE_TASK_TYPE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case CREATE_TASK_TYPE_ERROR:
        state = { 
          ...state, 
          CREATE_TASK_TYPE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------UPDATE_TASK_TYPE
      case UPDATE_TASK_TYPE:
        state = {
          ...state,
          loading: true,
        }
        break

      case UPDATE_TASK_TYPE_SUCCESS:
        state = {
          ...state,
          UPDATE_TASK_TYPE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case UPDATE_TASK_TYPE_ERROR:
        state = { 
          ...state, 
          UPDATE_TASK_TYPE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DELETE_TASK_TYPE
      case DELETE_TASK_TYPE:
        state = {
          ...state,
          loading: true,
        }
        break

      case DELETE_TASK_TYPE_SUCCESS:
        state = {
          ...state,
          DELETE_TASK_TYPE_SUCCESS: action.payload,
          loading: false,
        }
        break

      case DELETE_TASK_TYPE_ERROR:
        state = { 
          ...state, 
          DELETE_TASK_TYPE_ERROR: action.payload, 
          loading: false 
        }
        break

      // ---------------------------------------------DEFAULT
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default reducer
  